var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase */
import Vue from 'vue';
import Card from 'src/components/Card/Card';
import rpc from 'src/api/rpc';
import GenericTable from 'src/components/GenericTable/GenericTable.vue';
import Notify from 'quasar/src/plugins/Notify.js';import Dialog from 'quasar/src/plugins/Dialog.js';;
import getSessionContext from 'src/utils/context/getSessionContext';
import fullScreenLoading from 'src/utils/fullScreenLoading';
import { fetchMasters } from 'src/apps/utils/initializeApp';
export default Vue.extend({
    components: { Card, GenericTable },
    props: {
        visibleProp: { type: Boolean, default: null },
        userObjectProp: { type: Object, default: null }
    },
    data() {
        return {
            visible: false,
            data: [],
            currentTab: 'roles',
            newPassword: ''
        };
    },
    computed: {
        roleAssignments_genericTableProps() {
            var _a;
            return {
                applyToToBeCreatedRecord: (newRecord) => {
                    var _a;
                    return Object.assign(Object.assign({}, newRecord), { user_id: (_a = this.userObjectProp) === null || _a === void 0 ? void 0 : _a.id, role_id: 22 /* User with no permissions */ });
                },
                doNotApplyFilterModelLocallyProp: true,
                localEntityNameProp: 'controlled_actions.roles_orgs_apps_to_users',
                title: 'Assigned roles and role scopes',
                startingFilterModelProp: [{ field: 'app_id', predicate: 'containedIn', value: [this.currentAppId] }],
                flatTableProp: true,
                hideUploadListButton: true,
                hideFiltersAreSetButton: true,
                permanentInvisibleToUserFilterModelProp: [{ field: 'user_id', predicate: 'equals', value: (_a = this.userObjectProp) === null || _a === void 0 ? void 0 : _a.id }],
                hideDownloadListButton: true,
                hideTakeSnapshotButton: true,
                hideFullscreenButton: true,
                hideRefreshButton: true,
                hideSaveViewButton: true,
                createByAddingRowProp: true
            };
        },
        currentAppId() { return getSessionContext().app_id; },
        commonGenericTableProps() {
            var _a, _b;
            return {
                startingFilterModelProp: [
                    { field: 'user_id', predicate: 'equals', value: (_a = this.userObjectProp) === null || _a === void 0 ? void 0 : _a.id },
                    { field: 'instructor_user_id', predicate: 'equals', value: (_b = this.userObjectProp) === null || _b === void 0 ? void 0 : _b.id } // same as user_id. some modules below use instructor_user_id instead of user_id field name
                ],
                hideHeaderSlotProp: true,
                hideFiltersAreSetButton: true,
                hideDownloadListButton: true,
                hideTakeSnapshotButton: true,
                hideColumnSelectorButton: true,
                hideFullscreenButton: true,
                hideRefreshButton: true,
                hideSaveViewButton: true,
                createByAddingRowProp: true
            };
        },
        employeeRolesProps() {
            return Object.assign(Object.assign({}, this.commonGenericTableProps), { localEntityNameProp: 'employeeRoles.employeeRolesInOrgs', hideHeaderSlotProp: false });
        },
        orgLocationQualificationsProps() {
            return Object.assign(Object.assign({}, this.commonGenericTableProps), { localEntityNameProp: 'instructorScheduling.instructorOrgQualifications', subTitle: 'Defines which locations the instructor is qualified to teach at', hideHeaderSlotProp: false });
        },
        preferredSubstituteWhereProps() {
            return Object.assign(Object.assign({}, this.commonGenericTableProps), { localEntityNameProp: 'instructorScheduling.preferredSubstituteWhere', subTitle: 'Defines studios where the instructor is preferred substitution candidate', hideHeaderSlotProp: false });
        },
        classTypeQualificationsProps() {
            return Object.assign(Object.assign({}, this.commonGenericTableProps), { localEntityNameProp: 'instructorScheduling.instructorProductQualifications', subTitle: 'Defines which class types the instructor is qualified to teach', hideHeaderSlotProp: false });
        },
        classQualificationsProps() {
            return Object.assign(Object.assign({}, this.commonGenericTableProps), { localEntityNameProp: 'instructor_scheduling.instructor_qualifications', subTitle: 'Defines which Class qualifications the instructor is qualified to teach', hideHeaderSlotProp: false });
        },
        usersNativeIdsProps() {
            return Object.assign(Object.assign({}, this.commonGenericTableProps), { localEntityNameProp: 'users.users_native_ids' });
        },
        responseStatusMapping() {
            return {
                'ok': 'positive',
                'error': 'negative',
                'warning': 'warning',
                'info': 'info'
            };
        },
        roleAssignmentColumns_old() {
            const deleteHandler = this.deleteHandler;
            const cols = [
                { name: 'delete_button', label: '', field: '', cellContentIsHidden: (props) => Boolean(props.row.is_inherited), isButton: true, icon: 'mdi-trash-can-outline', buttonClickHandler: deleteHandler },
                { name: 'role_id', label: 'Role', align: 'left', field: 'role_id', references: this.references('controlled_actions.roles'), editable: true },
                { name: 'org_id', label: 'Org', align: 'left', field: 'org_id', references: this.references('orgs.orgs'), editable: true },
                { name: 'app_id', label: 'App', align: 'left', references: 'apps.apps', editable: true },
                { name: 'is_inherited', align: 'left', label: 'Role is inherited', field: 'is_inherited', isCheckbox: true, headerInfoTip: 'If this field is true, that means that the user has a role assigned at a higher level app/tenant combination than the one which you are currently logged in to. Such records cannot be altered from the current interface.' }
            ];
            return cols;
        },
        controlledActions() {
            return {
                create: 15,
                fetch: 52,
                update: 15,
                delete: 16,
                downloadList: 52,
                uploadList: -1
            };
        }
    },
    watch: {
        visible(newVal) {
            if (!newVal)
                this.$emit('unloadComponent');
        },
        visibleProp: {
            immediate: true,
            handler(newVal) { if (newVal !== null)
                this.visible = this.visibleProp; }
        }
    },
    created() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            fetchMasters(['controlled_actions.roles', 'apps.apps']);
            const response = yield rpc('controlled_actions.tenant_app_specific_roles_and_permissions_for_user_fetch', {
                user_id: (_a = this.userObjectProp) === null || _a === void 0 ? void 0 : _a.id,
                app_id: this.$store.state.authorizedUser.currentAppObject.id,
                tenant_id: this.$store.state.authorizedUser.currentTenantObject.id
            });
            this.data = response;
            if (this.data === null)
                this.data = [];
        });
    },
    methods: {
        setNewPassword() {
            var _a;
            fullScreenLoading.show({ message: 'Updating user password' });
            const payload = { id: (_a = this.userObjectProp) === null || _a === void 0 ? void 0 : _a.id, password: this.newPassword };
            this.$store.dispatch('users.users/updatePassword', payload).then((response) => {
                this.newPassword = '';
                fullScreenLoading.hide();
            });
        },
        rowIsLockedFunction(cellProps) { return cellProps.row.is_inherited; },
        references(entity) {
            if (!this.$store.state[entity].list.length) {
                this.$store.dispatch(`${entity}/fetch`, { pagination: { page_size: 0 } });
            }
            return this.$store.state[entity].list;
        },
        deleteHandler(cellProps, ctx, e) {
            Dialog.create({
                title: 'Confirm',
                message: 'Please confirm role deletion',
                cancel: true,
                persistent: true
            }).onOk(() => __awaiter(this, void 0, void 0, function* () {
                if (cellProps.row.is_inherited) {
                    Notify.create({ message: 'This user\'s role is inherited from a higher level app/tenant combination than the one you are currently logged in to. Therefore, this role cannot be removed from that user using your current interface.', color: 'negative' });
                }
                else {
                    const response = yield rpc('controlled_actions.roles_orgs_apps_to_users_delete', { id: cellProps.row.id });
                    if (response) {
                        // if (response.status === 'ok') ...
                        if (response.data)
                            this.data = response.data;
                        if (response.message)
                            Notify.create({ message: response.message, color: this.responseStatusMapping[response.status] });
                    }
                    // Do we need to handle the request errors or we'll rely on 'rpc()'?
                }
            })).onCancel(() => {
                // console.log('>>>> Cancel')
            }).onDismiss(() => {
                // console.log('I am triggered on both OK and Cancel')
            });
        },
        initiationOfRecordCreationHandler(newRecord, ctx) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield rpc('controlled_actions.roles_orgs_apps_to_users_create', {
                    role_id: 22,
                    org_id: this.$store.state.authorizedUser.currentOrgObject.id,
                    app_id: this.$store.state.authorizedUser.currentAppObject.id,
                    user_id: (_a = this.userObjectProp) === null || _a === void 0 ? void 0 : _a.id
                });
                if (response && response.result === 'Success') {
                    const newRec = response.data[0];
                    newRec.is_inherited = false;
                    this.data.push(newRec);
                    Notify.create({ message: 'A placeholder role has been successfully assigned to the user. Please change it as needed', color: 'positive' });
                }
            });
        },
        handleCellChange({ id, field, newVal }) {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield rpc('controlled_actions.roles_orgs_apps_to_users_update', { id, [field]: newVal });
                if (response) {
                    const idx = this.data.findIndex(r => r.id === id);
                    this.$set(this.data, idx, response[0]);
                }
            });
        }
    }
});
